<template>
  <div>
    <div class="button" @click="onClick">
      <a-icon type="arrows-alt" style="font-size: 18px" />
      <div>放大地图</div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState("mapTools", ["max"]),
  },
  methods: {
    ...mapMutations("mapTools", ["setMax"]),
    onClick() {
      this.setMax(this.max + 1);
    },
  },
};
</script>

<style lang="less" scoped>
.button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #999;
  font-size: 12px;
}
</style>